import { AlertTriangle, RefreshCw, Home, HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { getUserFriendlyErrorMessage, getRecoveryActions } from '@/utils/errorRecovery';

interface ErrorRecoveryProps {
  error: Error;
  onRetry?: () => void;
  className?: string;
}

export function ErrorRecovery({ error, onRetry, className }: ErrorRecoveryProps) {
  const message = getUserFriendlyErrorMessage(error);
  const actions = getRecoveryActions(error);

  const getIcon = (label: string) => {
    if (label.includes('Retry')) return <RefreshCw className="h-4 w-4" />;
    if (label.includes('Home')) return <Home className="h-4 w-4" />;
    if (label.includes('Support')) return <HelpCircle className="h-4 w-4" />;
    return null;
  };

  return (
    <Alert variant="destructive" className={className}>
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Something went wrong</AlertTitle>
      <AlertDescription className="mt-2">
        <p className="mb-4">{message}</p>
        <div className="flex flex-wrap gap-2">
          {onRetry && (
            <Button onClick={onRetry} size="sm" variant="outline">
              <RefreshCw className="h-4 w-4 mr-2" />
              Try Again
            </Button>
          )}
          {actions.map((action, index) => (
            <Button
              key={index}
              onClick={action.action}
              size="sm"
              variant={action.primary ? 'default' : 'outline'}
            >
              {getIcon(action.label)}
              <span className={getIcon(action.label) ? 'ml-2' : ''}>
                {action.label}
              </span>
            </Button>
          ))}
        </div>
      </AlertDescription>
    </Alert>
  );
}
